<template>
    <!-- 公众号选择 -->
    <Dialog ref="synchroMediaModal" :callback="synchroMediaSave" width="600" :title="title">
        <div slot="mdBox">
            <div class="warp clearfix">
                <div class="warp-item fl">
                    <div class="clearfix">
                        <div class="radio-warp clearfix">
                            <label class="checkbox-warp fl clearfix">
                                <label class="checkbox fl">
                                    <input type="radio" v-model="materialType" name="mediaType" value="1" class="radio-i"> 
                                    <span class="radio-ico"></span> 
                                </label>
                                <div class="hidden">微信号</div>
                            </label>
                            <label class="checkbox-warp fl clearfix" v-if="type === 2">
                                <label class="checkbox fl">
                                    <input type="radio" v-model="materialType" name="mediaType" value="2" class="radio-i"> 
                                    <span class="radio-ico"></span> 
                                </label>
                                <div class="hidden">微博号</div>
                            </label>
                            <label class="checkbox-warp fl clearfix" v-if="type === 2">
                                <label class="checkbox fl">
                                    <input type="radio" v-model="materialType" name="mediaType" value="3" class="radio-i"> 
                                    <span class="radio-ico"></span> 
                                </label>
                                <div class="hidden">头条号</div>
                            </label>
                        </div>
                        <div class="mt20">                           
                            <span class="fl mt5">选择标签：</span>
                            <div class="dropdown-toggle fl" style="width:189px;">
                                <div class="dropdown">
                                    <span>{{tagName}}</span>
                                    <i class="icons icons-down fr"></i>
                                </div>
                                <div class="drop-down">
                                    <ul class="dropdown-menu dropdown-menu1" role="menu">
                                        <li class="cp" @click="clickTag('全部');">全部</li>
                                        <li class="cp" v-for="(item,index) in tagList" :key="index" @click="clickTag(item.name);">{{item.name}}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>                        
                    </div>
                    <div class="search-warp mt20">
                        <input type="text" name="search" v-model="keyWord" placeholder="请输入关键字搜素" class="input-text" @keyup="screenList();"> 
                        <span class="search-btn" href="javascript:void(0);">
                            <i class="icons search-icon1"></i>
                        </span>
                    </div>
                    <div class="box h230 mt4">
                        <ul class="one-level">
                            <li class="li clearfix">
                                <label class="checkbox-warp clearfix">
                                    <label class="checkbox fl">
                                        <input type="checkbox" class="checkbox-i" @click="checkAll($event);" :checked="$utils.isIncludes(mediaIds,ids) == true && ids != ''? true : false"> 
                                        <span class="checkbox-ico"></span> 
                                    </label>
                                    <span>
                                        <span>{{tagName}}</span>
                                        <!-- <i class="icons up-icon"></i> -->
                                    </span>
                                </label>
                                <ul class="two-level">
                                    <li v-for="(item,index) in list" :key="index">
                                        <label class="checkbox clearfix">
                                            <div class="checkbox-inside fl">
                                                <input type="checkbox" v-model="mediaIds" class="checkbox-i" :value="item.type+'-'+item.id"> 
                                                <span class="checkbox-ico"></span> 
                                            </div>
                                            <div class="imgText hidden clearfix">
                                                <img :src="item.profileImgUrl" onerror="this.src='static/images/headImg.png'" class="img fl"/>
                                                <div class="hidden"><span class="name fl">{{item.screenName}}</span></div>
                                            </div>
                                        </label>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="warp-item fr">
                    <ul class="box select h354">
                        <li class="li clearfix" v-for="(item,index) in selectList" :key="index">
                            <div class="imgText hidden clearfix">
                                <img :src="item.profileImgUrl" onerror="this.src='static/images/headImg.png'" class="img fl"/>
                                <div class="hidden clearfix">
                                    <span class="name fl">{{item.screenName}}</span>
                                    <div class="clearfix fr">
                                        <i class="icons media-icons" :class="platformImg[item.type - 1]"></i>
                                        <a class="icons close-icon" href="javascript:void(0);" @click="delUser(item.type+'-'+item.id);"></a>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </Dialog>
</template>
<script>
import Dialog from './dialog.vue';
export default {
    components:{Dialog},
    name:'',
    props: {
        listPass:{//列表传输
            type:Boolean,
            default: false
        },
        dataArray: { 
            type: Array | Object
        }
    },
    data() {
        return {
            platformImg:['wx-icon','wb-icon','tt-icon'],
            materialType:1,//媒体类别 
            type:'',
            title:'',
            initialMediaList:[],//公众号初始列表
            list:[],//公号列表
            tagList:[],//标签列表
            tagName:'全部',//标签名
            keyWord:'',//关键词
            ids:[],//当前条件的IDS
            mediaIds:[],
            selectList:[] //公号已选列表 
        }
    },
    created () {
        
    },
    mounted () {
        
    },
    methods: {
        // 获取账户列表
        getUesrList () {
            let that = this;
            that.materialType = 1;
            let list = that.dataArray;
            that.initialMediaList = list;
            that.setList(list[0]);
            that.makeList();
        },
        // 生成列表数据
        setList (arr) {
            this.ids = [];
            this.list = arr;
            for(let i of arr){
                this.ids.push(i.type+'-'+i.id);
            }
        },
        // 获取分组标签
        getTabList () {
            let that = this;
            that.$api.post('label/taglist',{type:that.materialType},r => {
                that.$parent.$parent.returnCode(r,function(){
                    that.tagList = r.data;
                })
            })
        },
        // 标签筛选
        clickTag (name) {
            let that = this;
            that.tagName = name;
            that.screenList();
        },
        // 筛选
        screenList () {
            let that = this;
            let keyWord = that.keyWord;//搜索关键字
            let tagName = that.tagName;//标签名
            let initialList = that.initialMediaList[that.materialType - 1];//获取初始列表
            let list = [];
            // 标签筛选
            if(tagName === '全部'){
                list = initialList;
            }else{
                for(let i of initialList){
                    if(i.tags.indexOf(tagName) != -1){
                        list.push(i);
                    }
                }
            }
            // 关键词筛选
            let lists = [];
            if(keyWord != ''){
                for(let i of list){
                    if(i.screenName.indexOf(keyWord) != -1){
                        lists.push(i);
                    }
                }
            }else{
                lists = list;
            }
            that.ids = [];
            for(let i of lists){
                that.ids.push(i.type+'-'+i.id);
            }
            that.list = lists;
        },
        // 全选状态
        checkAll (e) {
            let that = this;
            let list = that.list;
            let ids = that.ids;
            let mediaIds = that.mediaIds;
            let checked = e.target.checked;
            if(checked == true){//全选
                mediaIds = mediaIds.concat(ids);
            }else{//全不选
                for(let j of ids){
                    mediaIds = mediaIds.filter(item => item !== j);
                }
            }
            that.mediaIds = mediaIds;
        },
        // 删除预选列表
        delUser (id) {
            let that = this;
            let selectList = that.selectList; 
            let mediaIds = that.mediaIds;
            let ids = [];
            for(let i of mediaIds){//重新拼装数组
                ids.push(i);
            }
            let index = ids.indexOf(id);
            ids.splice(index,1);
            that.mediaIds = ids;
            that.makeList();
        },
        // 生成已选列表
        makeList () {
            let that = this;
            let mediaIds = that.mediaIds;
            let initialList = '';
            initialList = that.initialMediaList;
            let selectList = [];
            if(initialList.length > 0){
                for(let i of initialList){
                    for(let n of i){
                        for(let j of mediaIds){
                            if(n.type+'-'+n.id === j){
                                selectList.push(n);
                            }
                        }
                    }
                }
            }
            that.selectList = selectList;
        },
        // 同步到公众号后台
        synchroPublicNumber (type,title) {
            let that = this;
            that.type = type;
            that.title = title;
            that.mediaIds = [];
            that.selectList = [];
            that.getTabList();
            that.getUesrList();
            that.$refs.synchroMediaModal.showMaskFun();
        },
        // 确认同步到公众号后台
        synchroMediaSave () {
            let that = this;
            if(that.mediaIds.length <= 0){
                that.$utils.alertText('请选择媒体账号');
                return;
            }
            that.$refs.synchroMediaModal.closeMask();
            if(that.listPass){
                that.$emit('userCallback',[that.mediaIds,that.selectList]);
            }else{
                that.$emit('userCallback',that.mediaIds);
            }
        }
    },
    watch:  {
        materialType (val) {
            this.getTabList();
            this.setList(this.initialMediaList[val-1]);
        },
        mediaIds (val) {
            this.makeList(); 
        }
    }
}
</script>
<style lang="" scoped>
    
</style>



// WEBPACK FOOTER //
// src/components/mediaSelect.vue